import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import "./index.css";
import { useEffect, useState } from "react";
import { useFilters } from "../../hooks/useFilters";
import Swal from "sweetalert2";
import { VendorCart } from "../../contexts/FiltersContext";

type Options = {
    select: string
    value: string
}

export function FilterSellerCart() {

    const navigate = useNavigate();
    const { pluginspace_id } = useParams();
    const { setVendorCart } = useFilters();


    const [selectedOptions, setSelectedOptions] = useState<Options[]>([]);
    const [options, setOptions] = useState<Options[]>([
        { select: 'Pendente', value: 'open' },
        { select: 'Pago', value: 'used' },
        { select: 'Cancelado', value: 'canceled' },
    ]);

    const [startDate, setStartDate] = useState<string>('');
    const [endDate, setEndDate] = useState<string>('');


    const handleCheckboxChange = (option: Options) => {
        // Verifica se a opção já está no array de opções selecionadas
        if (selectedOptions.includes(option)) {
            // Remove a opção se já estiver selecionada
            setSelectedOptions(selectedOptions.filter((selectedOption) => selectedOption !== option));
        } else {
            // Adiciona a opção se não estiver selecionada
            setSelectedOptions([...selectedOptions, option]);
        }
    };


    function clearFilter() {
        setStartDate('')
        setEndDate('')
        setSelectedOptions([])

    }

    const setFilter = () => {
        if ((!startDate && endDate) || (startDate && !endDate)) {
            Swal.fire({
                icon: "warning",
                title: "Atenção!",
                text: "Verifique as datas",
            });
        } else {
            const filter: VendorCart = {
                initAt: startDate ?? null,
                finishAt: endDate ?? null,
                order: '',
                cpfCustomer:'',
                status: selectedOptions.map(el => el.value)
            }

            setVendorCart(filter)

            navigate(`/${pluginspace_id}/sellerOrder`)
        }



    }


    return (
        <div className="FilterContainer">
            <div className="FilterMain">
                <div className="title-search">
                    <h2>Filtrar Carrinhos</h2>
                    <svg
                        width="17"
                        height="17"
                        viewBox="0 0 17 17"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        onClick={() => navigate(`/${pluginspace_id}/sellerOrder`)}
                    >
                        <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M0.978551 2.21657L6.957 8.2395L0.978551 14.2624L2.97137 16.2701L8.94981 10.2471L14.9283 16.2701L16.9211 14.2624L10.9426 8.2395L16.9211 2.21657L14.9283 0.208931L8.94981 6.23186L2.97137 0.208931L0.978551 2.21657Z"
                            fill="#636363"
                        />
                    </svg>
                </div>
                <div className="FilterBody">

                    <div className="StatusOptions">
                        <div className="DateRangeOptions-header">
                            <p>Filtrar por status </p>
                        </div>

                        <div className="StatusOptionsDiv">
                            {options.map((option) => (
                                <div key={option.value} className="checkbox-option">

                                    <input
                                        type="checkbox"
                                        id={`${option.value}`}
                                        className="checkboxInput"
                                        checked={selectedOptions.includes(option)}
                                        onChange={() => handleCheckboxChange(option)}
                                    />
                                    <label htmlFor={`${option.value}`}>{option.select}</label>

                                </div>
                            ))}
                        </div>

                    </div>

                    <div className="DateRangeOptions" style={{ marginTop: '2rem' }}>
                        <div className="DateRangeOptions-header">
                            <p>Filtrar por data </p>
                        </div>
                        <div className="container">
                            <div className="date-input">
                                <label htmlFor="startDateInput">De</label>
                                <input
                                    type="date"
                                    id="startDateInput"
                                    className="custom-date-input"
                                    placeholder="DD/MM/AAAA"
                                    value={startDate}
                                    onChange={(e) => setStartDate(e.target.value)}
                                />
                            </div>
                            <div className="date-input">
                                <label htmlFor="endDateInput">Até</label>
                                <input
                                    type="date"
                                    id="endDateInput"
                                    className="custom-date-input"
                                    placeholder="DD/MM/AAAA"
                                    value={endDate}
                                    onChange={(e) => setEndDate(e.target.value)}
                                />
                            </div>
                        </div>
                    </div>


                    <div className="OptionsButton">

                        <button className="buttonFilter" onClick={setFilter}> <p>Aplicar filtros</p></button>


                        <button className="buttonClearFilter" onClick={clearFilter}> <p>Limpar filtros</p> </button>

                    </div>
                </div>

            </div>

        </div>
    )
}